import '../vendors/setup.js';
import '../i18n/setup.js';
import '../visualizations/index.js';
import { installRailsRemote } from '../modules/rails_remote.js';
import { dispatchPageLoad } from '../modules/page_lifecycle.js';

import { bindUniversalCloseButton } from '../legacy/universal_close_button';
import { bindOutboundBannerLinks } from '../legacy/outbound_banner_links';
import { bindModalsFromQueryParams } from '../legacy/modal_from_query_params';
import { bindCookieWarning } from '../legacy/cookie_warning';

import '../legacy/toastr_options.js';
import '../legacy/render_bootstrap_errors.js';

import '../legacy/ahoy_desal.js';
import '../legacy/old_application_core.js';
import '../legacy/companies_window.js';
import '../legacy/company_show.js';
import '../legacy/cookie_banner.js';
import '../legacy/downloads.js';
import '../legacy/home.js';
import '../legacy/main_menu.js';
import '../legacy/project_show.js';
import '../legacy/svg_fallback.js';
import '../legacy/webinars.js';

import '../legacy/analysis.js';
import '../legacy/no_data_to_display.js';

installRailsRemote();

bindUniversalCloseButton();
bindOutboundBannerLinks();
bindModalsFromQueryParams();
bindCookieWarning();

dispatchPageLoad();
